//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _rma from './rma';
export const rma = _rma;
export default {rma};

